import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Grid,
    Typography,
  } from "@mui/material";
  import React from "react";
  
  // Using the same image imports as the original
  import image1 from "../assets/img/image-1.png";
  import image2 from "../assets/img/image-2.png";
  import image3 from "../assets/img/image-3.png";
  import image4 from "../assets/img/image-4.png";
  
  const SecureDataTransferSection = () => {
    // Data for feature cards to enable mapping
    const featureCards = [
      {
        id: 1,
        title: "Secure and Reliable",
        description:
          "Experience the ultimate data storage solution, designed to protect your valuable files and provide you with peace of mind",
        buttonText: "Order now",
        image: image1,
      },
      {
        id: 2,
        title: "Top-Notch Security",
        description:
          "Safeguard your digital assets with our cutting-edge security measures, delivering unparalleled protection for your files",
        buttonText: "Order now",
        image: image2,
      },
      {
        id: 3,
        title: "Flexible Accessibility",
        description:
          "Access your files anytime, anywhere. Our platform offers seamless integration, allowing you to manage your data with ease",
        buttonText: "Order now",
        image: image3,
      },
      {
        id: 4,
        title: "24/7 Support",
        description:
          "Our dedicated team is available around the clock to assist you with any questions or concerns, ensuring a hassle-free experience",
        buttonText: "Order now",
        image: image4,
      },
    ];
  
    return (
      <Box id="services-section" sx={{ bgcolor: "#1a1a1a", py: 8, width: "100%" }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                color: "#fcfcfc",
                fontFamily: "'Spline_Sans_Mono-SemiBoldItalic', Helvetica",
                fontWeight: 600,
                fontStyle: "italic",
                fontSize: { xs: "2.5rem", md: "4.2rem" },
                lineHeight: 1.2,
                mb: 2,
              }}
            >
              Secure Data Transfer
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#595755",
                fontFamily: "'Space_Grotesk-Regular', Helvetica",
                maxWidth: "460px",
                mx: "auto",
                lineHeight: 1.8,
              }}
            >
              Transfer your files with confidence. Our platform ensures smooth,
              secure, and hassle-free migration of your photos, videos, and more
            </Typography>
          </Box>
  
          <Grid container spacing={2} justifyContent="center" sx={{flexWrap: {xs: "wrap", sm: "nowrap"}}}>
            {featureCards.map((card) => (
              <Grid item xs={12} sm={6} md={3} key={card.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "#1a1a1a",
                    border: "1px solid #bab9ba",
                    borderRadius: 0,
                    p: 2,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                    <CardMedia
                      component="img"
                      image={card.image}
                      alt={card.title}
                      sx={{
                        width: "auto",
                        height: 80,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      p: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        color: "#c7c6c6",
                        fontFamily: "'Space_Grotesk-Medium', Helvetica",
                        textAlign: "center",
                        mb: 2,
                        fontSize: "1.2rem",
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#565455",
                        fontFamily: "'Space_Grotesk-Regular', Helvetica",
                        textAlign: "center",
                        mb: 3,
                        lineHeight: 1.8,
                      }}
                    >
                      {card.description}
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: "#b19649",
                        color: "#b19649",
                        borderRadius: card.id === 1 ? "11px" : "40px",
                        textTransform: "none",
                        px: 3,
                        mt: "auto",
                        "&:hover": {
                          borderColor: "#d4b45a",
                          backgroundColor: "rgba(177, 150, 73, 0.04)",
                        },
                      }}
                      onClick={() => {
                        const section = document.getElementById("order-now-section");
                        if (section) {
                          section.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      {card.buttonText}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  };
  
  export default SecureDataTransferSection;